/* TIKIS Motion: Hero-Choreografie, Scroll-Reveal, sanfte Zeiger-Parallaxe. Nutzt Motion (motion.dev), fällt ohne Bibliothek auf statisch zurück. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var M = window.Motion;
  var EASE = [0.23, 1, 0.32, 1];

  function revealAll() {
    root.classList.add('tk-show');
    document.querySelectorAll('[data-tk-r]').forEach(function (e) { e.classList.add('is-in'); });
  }
  if (!M || reduce) { revealAll(); return; }

  // Sicherheitsnetz: nach 4 s ist alles sichtbar, egal was passiert
  var safety = setTimeout(revealAll, 4000);

  function hero(h) {
    if (h.dataset.tkDone) return;
    h.dataset.tkDone = '1';
    var items = h.querySelectorAll('[data-tk-item]');
    var cards = h.querySelectorAll('[data-tk-card]');
    M.animate(items, { opacity: [0, 1], transform: ['translateY(14px)', 'translateY(0px)'] },
      { duration: 0.6, delay: M.stagger(0.07), ease: EASE });
    var rot = [-4, 5, -2];
    Array.prototype.forEach.call(cards, function (c, i) {
      var r = rot[i % rot.length];
      M.animate(c, { opacity: [0, 1] }, { duration: 0.4, delay: 0.15 + i * 0.09, ease: EASE });
      M.animate(c, { transform: ['translateY(28px) rotate(' + (r * 2) + 'deg) scale(0.94)', 'translateY(0px) rotate(' + r + 'deg) scale(1)'] },
        { type: 'spring', duration: 0.9, bounce: 0.2, delay: 0.15 + i * 0.09 });
    });
    root.classList.add('tk-show');

    // Zeiger-Parallaxe nur für echte Zeigergeräte
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var inner = h.querySelectorAll('.tkh__card-in');
      var depth = [10, 16, 7];
      var ticking = false, px = 0, py = 0;
      h.addEventListener('pointermove', function (e) {
        var b = h.getBoundingClientRect();
        px = (e.clientX - b.left) / b.width - 0.5;
        py = (e.clientY - b.top) / b.height - 0.5;
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function () {
            Array.prototype.forEach.call(inner, function (el, i) {
              var d = depth[i % depth.length];
              el.style.transform = 'translate3d(' + (px * d * -1).toFixed(1) + 'px,' + (py * d * -1).toFixed(1) + 'px,0)';
            });
            ticking = false;
          });
        }
      });
      h.addEventListener('pointerleave', function () {
        Array.prototype.forEach.call(inner, function (el) { el.style.transform = 'translate3d(0,0,0)'; });
      });
    }
  }

  function reveal(box) {
    if (box.dataset.tkDone) return;
    box.dataset.tkDone = '1';
    var targets = box.querySelectorAll('[data-tk-r]');
    if (!M.inView) { targets.forEach(function (t) { t.classList.add('is-in'); }); return; }
    M.inView(box, function () {
      M.animate(targets, { opacity: [0, 1], transform: ['translateY(18px)', 'translateY(0px)'] },
        { duration: 0.55, delay: M.stagger(0.06), ease: EASE });
      targets.forEach(function (t) { t.classList.add('is-in'); });
    }, { margin: '0px 0px -10% 0px' });
  }

  function init() {
    document.querySelectorAll('[data-tk-hero]').forEach(hero);
    document.querySelectorAll('[data-tk-reveal]').forEach(reveal);
    clearTimeout(safety);
    safety = setTimeout(revealAll, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
